import type * as THREE from 'three'

/**
 * Imperative handle to the live renderer.
 *
 * The export button lives in the DOM panels, outside the R3F tree, and the
 * export itself must run as one synchronous block — so it reaches the renderer
 * through this module rather than through React state.
 */
export interface SceneHandle {
  gl: THREE.WebGLRenderer
  scene: THREE.Scene
  camera: THREE.OrthographicCamera
  /** Current on-screen aspect, width / height. */
  aspect: number
}

let handle: SceneHandle | null = null

export function setSceneHandle(next: SceneHandle | null): void {
  handle = next
}

export function getSceneHandle(): SceneHandle | null {
  return handle
}
